import { motion, useMotionValue } from "framer-motion";
import { useState } from "react";
import { hasPackshotImage, packshotUrl } from "@/packshots";

const packshotSpring = { type: "spring", stiffness: 200, damping: 22 };

// Displays a real AI-generated packshot photo when one exists, otherwise falls back to
// the 3D letter tile so every product still has a visible packshot.
export default function Packshot({ product, size = "modal" }) {
  const rotateY = useMotionValue(0);
  const rotateX = useMotionValue(0);
  const [errored, setErrored] = useState(false);

  const handleMove = (event) => {
    const bounds = event.currentTarget.getBoundingClientRect();
    const px = (event.clientX - bounds.left) / bounds.width - 0.5;
    const py = (event.clientY - bounds.top) / bounds.height - 0.5;
    rotateY.set(px * 18);
    rotateX.set(-py * 14);
  };
  const reset = () => { rotateY.set(0); rotateX.set(0); };

  const useImage = hasPackshotImage(product.name) && !errored;
  const sizeClass = size === "modal" ? "packshot-3d-large" : "";

  return (
    <div
      className={`packshot-3d ${sizeClass}`}
      onMouseMove={handleMove}
      onMouseLeave={reset}
      data-testid="product-packshot"
    >
      <motion.div
        className="packshot-3d-inner"
        style={{ rotateX, rotateY }}
        transition={packshotSpring}
      >
        {useImage ? (
          <img
            className="packshot-photo"
            src={packshotUrl(product.name)}
            alt={`${product.name} pack`}
            onError={() => setErrored(true)}
            loading="lazy"
          />
        ) : (
          <>
            <span className="packshot-face packshot-face-front">
              <b>{product.mark}</b>
              <small>NAWAN</small>
            </span>
            <span className="packshot-face packshot-face-back" />
          </>
        )}
        <span className="packshot-shadow" />
      </motion.div>
    </div>
  );
}
